$(document).ready(function() {
  var playButton = document.getElementById('play-video');
  playButton.addEventListener('click', playVideoInModal);

  var playButtonMobile = document.getElementById('play-video-mobile');
  if (playButtonMobile) {
    playButtonMobile.addEventListener('click', playVideoInModal);
  }

  var closeButton = document.getElementById('close');
  closeButton.addEventListener('click', function() {
    console.log('close clicked');
    var videoPlayer = document.getElementById('video-player');
    videoPlayer.pause();
  });

  function playVideoInModal() {
    openModal('#vendor-payments-modal', 'vendor-payments-modal');
    var videoPlayer = document.getElementById('video-player');
    videoPlayer.play();
  }
});
